module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_7.af9e4333.png";